import ShapeNode from './shape/shape.node';
import Swimlane from './swimlane/swimlane.node';
import SwimlaneGroup from './swimlane/swimlane-group.node';
import { NodeTypes } from '@xyflow/react';

export const nodeTypes = {
  shape: ShapeNode,
  swimlane: Swimlane,
  swimlaneGroup: SwimlaneGroup,
} as unknown as NodeTypes;
